var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 424,
    viewBox: "0 0 424 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_17746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.17 119.37C336.33 122.36 339.49 125.36 342.65 128.35",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.08 172.25C377.37 174.11 380.07 180.13 382.5 186.24C383.64 189.11 384.22 192.2 385.05 195.2",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.81 84.46C279.79 87.09 281.76 89.73 284.69 93.63C285.26 95.78 286.27 99.6 287.29 103.42",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.89 25.5901C245.23 27.4201 243.79 29.5401 241.86 31.0201C237.69 34.2101 231.57 36.1401 229.3 40.2601C224.99 48.0901 217.34 55.0501 219.46 65.5001",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5 377.77C202.33 383.92 203.65 390.06 203.88 396.23C204.28 406.6 199.63 412.77 189.52 416.68C189.52 416.68 182.61 422.45 174.56 422.67C162.67 423.79 151.32 421.53 141.78 414.5C134.75 409.32 129 402.39 122.69 396.23",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.53 258.55C194.18 259.71 196.87 263.06 199.01 267.03",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7 396.73C113.72 397.56 105.71 399.28 97.77 399.01C87.23 398.65 77.63 394.52 72.52 384.66C69.45 378.73 68.14 371.84 66.44 365.28C65.85 362.99 65.36 361.19 62.84 360.83C52.12 359.31 44.93 353.06 39.89 343.86C39.32 342.81 38.57 341.86 37.91 340.86C32.85 333.3 30.08 324.97 31.6 315.95C32.3 311.82 31.76 306.69 36.41 303.95C36.41 303.95 33.96 299.49 33.92 288.98C33.69 286.51 34.42 286.65 34.42 285.99",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.19 140.32C124.36 142.32 124.9 144.36 124.62 146.3C123.57 153.69 126.71 159.3 131.67 164.27",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.02 237.1C200.72 243.31 207.56 255.5 200.06 270",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36 40.0601C260.02 40.0601 263.68 40.1301 267.33 40.0101C268.34 39.9801 269.33 39.3901 270.32 39.0601",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.24 357.82C108.2 362.61 112.43 360.21 115.72 360.81",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05 199.19C384.68 209.24 379.09 215.95 371.08 221.14",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11 39.5599C158.6 39.5599 162.09 39.5199 165.58 39.5799C166.91 39.6099 168.24 39.8899 169.57 40.0599",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.76 180.23C292.87 189.62 283.55 190.43 273.82 189.56V203.67",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.44 375.28C222.81 370.94 219.8 366.85 221.95 361.81L219.46 355.82C216.32 349 218.51 343.04 222.45 337.36C223.27 336.19 223.23 334.66 224.06 333.5",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.69 367.79C123.51 374.99 127.14 379.83 133.15 383.28C134.58 384.1 135.83 385.25 137.16 386.25",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8 261.04C79.8 260.87 78.81 260.69 77.81 260.54C68.58 259.16 60.73 255.66 55.81 247.1C53.61 243.27 51.11 239.55 48.28 236.18C46.88 234.52 44.39 232.78 42.4 232.77C33.71 232.76 26.52 229.37 19.96 224.12C19.96 224.12 16.14 222.89 14.97 218.13C14.46 205.64 18.02 194.93 29.06 186.77C26.47 174.89 27.29 163.58 40.22 155.92C39.48 153.15 38.58 150.25 37.95 147.28C35.96 138.01 35.12 128.75 37.39 119.34C40.72 105.53 51.51 98.1999 61.87 90.4199",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34 180.23C268 183.22 270.66 186.22 273.32 189.21",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.51 187.71C407.08 193.94 409.81 203.67 410.91 214.16C411.08 215.77 410.31 217.48 409.98 219.14",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 362.81C143.48 366.8 144.63 370.76 145.08 374.79C146.16 384.53 152.95 388.26 161.11 390.74C162.27 391.09 163.44 391.41 164.6 391.74",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33 24.1001C269.17 19.6101 268.5 14.9101 266.72 10.6801C263.97 4.11012 258.43 1.49012 251.38 1.06012C244.53 0.640119 238.47 2.53012 232.96 6.20012C228.13 9.42012 225.77 14.1001 225.33 20.1001C224.84 26.6101 224.57 32.8801 228.44 38.5701",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8999 251.57C40.8099 256.34 41.4699 261.47 45.2499 265.66C49.7399 270.63 55.6899 272.12 61.3399 274.52",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35 272.52C255.53 276.19 249.34 278.87 242.4 279.5",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2699 259.05C92.4399 266.53 90.4199 273.98 88.8999 281.52C88.4599 283.69 89.4499 286.15 89.7799 288.48",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64 380.76C138.32 385.91 131.01 391.07 123.69 396.22",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13 84.46C145.8 87.45 143.47 90.45 141.15 93.44",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8999 197.19C40.2299 200.85 41.4599 204.54 42.9099 208.16C44.9299 213.2 48.0999 217.35 52.8599 220.14",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.15 90.9399C347.12 93.6899 350.02 98.5199 350.63 104.91C350.8 106.74 350.96 108.57 351.13 110.4",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.06 163.27C380.79 161.01 383.53 158.76 386.42 156.37C392.88 159.99 396.88 166.33 397.5 174.74C398.05 182.24 397.04 189.29 391.03 194.69",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.01 229.12C393.63 230.81 388.5 233.23 382.54 232.8C380.97 232.69 378.83 234.63 377.64 236.16C374.42 240.31 371.68 244.82 368.56 249.05C362.27 257.59 353.24 260.48 343.14 261.04",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.86 159.28C259.4 160.93 259.94 162.58 260.75 165.04C250.5 163.47 243.53 169.27 236.41 174.74",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8399 274.01C59.1599 278.52 59.1199 284.1 60.5599 288.91C63.1199 297.45 66.5299 305.83 70.4499 313.85C74.3299 321.81 81.8299 325.34 90.2699 326.87C101.1 328.83 111.99 330.59 122.66 326.32C126.64 324.73 130.33 322.39 134.16 320.4",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79 90.9399C76.47 94.8599 74.29 101.93 74.81 110.39",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.25 140.32C301.25 141.82 301.19 143.32 301.26 144.81C301.54 150.64 300.6 156.09 296.8 160.8C296.03 161.75 295.76 163.1 295.27 164.26",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63 112.39C359.44 112.14 365.7 114.55 372.08 116.38",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.29 310.93C287.12 314.09 288.95 317.25 290.78 320.41",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 180.23C155.23 183.61 151.25 187.97 151.18 194.7C151.15 197.69 151.78 200.69 152.12 203.68",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.25 365.8C301.95 375.56 297.08 382.61 288.25 385.67C287.31 385.99 285.95 385.09 284.79 384.76",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45 257.05C221.79 250.96 223.97 245.54 227.44 240.59",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.94 376.77C225.27 373.65 226.72 376.09 227.91 376.8C232.78 379.71 237.56 382.78 242.42 385.7C242.91 385.99 243.73 385.74 244.39 385.74",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.31 190.21C72.15 191.37 69.52 192.1 67.92 193.79C64.76 197.13 62.17 201.01 59.34 204.67",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 93.4299C199.83 96.5899 199.47 100.03 200.63 102.86C204.24 111.69 202.48 120.84 203.03 129.85C203.47 137.11 200.97 143.17 195.99 148.28C194.68 149.62 193.03 150.64 191.53 151.8",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31 379.77C280.73 374.19 283.13 368.79 282.3 362.81",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6 207.17C158.82 205.91 156.04 204.65 153.6 203.54C126.62 211.26 126.67 233.7 134.67 249.07",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.04 251.07C386.37 253.23 385.73 255.4 385.04 257.55C382.35 265.95 376.18 270.53 368.09 273.03C366.68 273.47 365.33 274.11 363.98 274.66C366.45 282.69 366.07 290.16 362.62 297.47C360.52 301.91 358.5 306.39 356.64 310.94C352.42 321.28 343.83 325.52 333.66 327.33C328.07 328.33 322.37 329.2 316.71 329.26C309.34 329.34 302.38 327.35 296.24 322.92C293.68 321.07 293.37 321.17 290.77 321.9",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.49 220.14C406.83 222.97 404.17 225.79 401.51 228.62",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7899 129.35C78.7999 136.41 73.6499 142.66 71.0699 150.72C68.3299 159.3 67.3299 167.75 69.4499 176.21C73.5099 192.33 84.5699 202.33 99.7399 208.17",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.01 228.62C407.95 234.43 410.2 242.83 411.03 252.06C412.33 266.52 403.28 274.58 393.03 281.99L392.03 287.98C391.36 292.3 390.7 296.63 390.03 300.95L392.03 306.94C392.86 312.59 395.03 318.44 394.25 323.86C392.55 335.7 385.91 345.38 377.56 353.83C373.31 358.14 367.97 360.06 362.1 360.82",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2 345.85C327.19 348.84 330.22 351.8 333.17 354.84C338.26 360.07 344.91 360.75 351.63 361.33C354.46 361.58 357.28 361.98 360.11 362.31",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.9 145.31C231.29 155.48 227.26 167.85 223.58 180.27C222.22 184.84 222.14 189.87 222.01 194.7C221.78 203.67 221.41 212.7 222.19 221.61C222.52 225.4 225.5 229 227.47 232.58C228.37 234.22 229.75 235.6 230.92 237.09",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7899 360.31C86.7799 363.97 85.4999 368.25 88.7799 371.28",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75 345.85C97.43 349.84 93.6 354.7 88.63 357.56C84.38 360 78.83 360.26 73.81 361.27C71.54 361.73 69.16 361.65 66.84 361.82",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.27 57.52C298.82 59.91 302.2 63.25 303.25 68.49",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.93 240.09C228.64 238.97 229.36 237.85 229.82 237.13C240.73 241.93 250.54 246.25 260.35 250.57",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6 6.64004C151.01 6.53004 144.13 10.31 137.58 15.52C133.33 18.9 132.85 24.04 130.93 27.2C131.56 34.52 132.11 41.03 132.67 47.54",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05 305.94C379.93 308.6 374.53 308.27 369.09 307.44",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8299 153.79C66.9999 152.29 65.1599 150.81 63.3499 149.3C58.5599 145.33 52.8599 144.38 46.8899 144.31",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9399 228.62C20.1399 233.97 17.1099 239.51 15.2599 246.02C12.3199 256.34 14.9299 264.86 21.5299 272.44C24.6699 276.05 28.8399 278.74 32.3599 282.05C33.3799 283.01 33.7399 284.65 34.4099 285.98",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38 85.45C253.48 89.01 256.23 92.34 255.37 96.92",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 164.77C170.64 165.88 176.3 164.4 180.6 168.72C182.67 170.8 185.21 172.42 187.54 174.25",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32 112.39C66.53 112.24 60.17 114.18 53.87 116.38",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67 55.52C132.34 56.19 132.17 57.22 131.65 57.46C121.13 62.27 121.33 71.56 121.65 80.96C121.67 81.61 121.03 82.29 120.7 82.95",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.99 65.5C204.48 67.78 202.96 70.07 201.44 72.37C199.01 76.03 197.88 80.39 198.2 84.77C198.46 88.25 198.66 92.12 199.51 93.43",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54 145.31C191.78 149.82 193.46 157.96 196.85 164.84C199.45 170.11 200.66 176.07 202.49 181.72C202.65 182.22 202.96 182.72 202.97 183.22C203.16 195.36 203.68 207.51 203.36 219.63C203.15 227.63 198.84 234.2 191.93 237.94C183.12 242.71 173.72 246.4 164.58 250.56",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8999 305.94C45.8799 309.32 51.5199 307.42 56.8599 307.94",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.43 221.14C234.67 214.48 239.17 209.54 247.38 210.76C250.13 211.17 252.76 212.56 255.36 213.69C257.83 214.76 259.51 214.37 260.36 211.67",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65 310.93C138.73 313.98 136.82 317.02 134.94 320.01C135.78 326.77 133.67 334.26 138.66 340.36",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35 164.77C264.01 165.6 266.67 166.43 269.33 167.26",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.13 219.14C350.13 219.31 348.14 219.51 346.14 219.63C337.33 220.16 332.03 225.08 329.18 233.11",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 333.87C199.34 337.03 197.64 340.17 196.04 343.36C195.67 344.09 195.68 345.01 195.51 345.84",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52 217.64C188.46 210.66 179.18 208.24 172.63 212.75C170.96 213.9 167.73 212.82 167.58 216.15",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.37 97.4199C250.38 97.7499 246.39 98.0899 242.4 98.4199",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.81 381.26C274.66 384.59 269.57 388.02 264.3 391.16C262.93 391.98 261.02 391.9 259.36 392.23",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49 64.4999C207.53 55.9499 201.62 50.2099 198 43.5499C197.54 42.6999 196.99 41.8999 196.19 40.6099C199.62 35.2799 200.78 29.1799 200.58 22.5899C200.22 10.9899 190.38 1.11992 178.55 1.16992C175.39 1.17992 172.08 0.929915 169.1 1.74992C160.71 4.05992 157.99 11.0899 156.1 18.6099C155.6 20.6099 155.1 22.5999 154.6 24.5999",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.44 94.4299C224.51 106.01 220.91 117.33 221.87 129.35C222.62 138.73 225.74 146.54 233.92 151.79",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.25 71.49V79.47",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.22 139.33C312.23 139.66 308.24 140 304.25 140.33",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1 361.31C360.27 364.14 359.24 366.92 358.65 369.8C357.16 377.04 354.82 384.28 349.93 389.55C344.38 395.54 336.54 398.62 328.19 399.15C321.65 399.57 315.09 399.44 308.72 397.28C307.03 396.71 305.08 396.89 303.25 396.72",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.69 179.23C129.63 186.72 135.9 189.01 143.15 189.69C145.8 189.94 148.47 190.04 151.13 190.2",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.28 322.9C289.99 327.94 291.37 333.21 288.27 337.85C287.55 338.92 286.62 339.86 285.79 340.85",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55 385.75C187.54 382.76 192.48 379.69 197.55 376.84C198.43 376.34 199.84 376.77 201 376.77C201 376.77 204.23 372.37 203 361.31C200.01 362.64 197.13 364.45 194 365.2C186.55 366.99 179.02 367.02 171.57 364.82C170.96 364.64 170.25 364.8 169.58 364.8",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.33 345.85C268.63 357.46 263.26 364.56 247.87 366.17C240.45 366.95 232.78 366.95 225.94 362.81",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.13 190.21C344.75 196.07 339.71 202.37 332.15 205.61C329.66 206.68 326.86 207 324.2 207.67",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6 133.34C168.55 142.46 169.81 152 165.31 162.86C163.22 167.91 159.33 165.19 156.62 166.76",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34 206.17C274.94 202.31 285.13 206.2 290.73 216.17C293.13 220.44 294.98 225.01 297.06 229.41C294.91 236.14 292.84 242.6 290.78 249.06",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.91 408.7C237.74 411.19 237.58 413.69 237.41 416.18",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.95 66.5C222.86 70.55 225.76 74.6 228.85 78.91C227.54 80.56 227.98 92.49 226.43 94.44",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.77 48.0399C293.1 43.2199 293.29 38.3799 293.8 33.5799C294.99 22.4399 290.46 14.4599 279.77 10.2199C275.49 8.51989 270.83 7.79989 266.34 6.63989",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67 18.61C127.35 16.45 122.12 14.02 116.69 12.19C109.27 9.70004 102.13 11.11 96.36 16.23C92.34 19.79 89.13 24.32 85.82 28.62C82.11 33.45 83.01 39.05 83.79 44.55C84.1 46.72 84.45 48.87 84.78 51.04",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.53 408.7C187.85 411.2 186.52 413.91 188.53 416.18",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36 97.4199C264.71 98.7199 272.78 100.67 277.78 108.41C280.73 112.98 283.19 117.9 286.35 122.31C289.86 127.19 293.93 131.67 297.75 136.33",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55 27.5901L196.01 39.5601",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.18 230.12C121.45 228.47 113.74 227.63 106.24 231.12C103.54 232.38 100.89 233.71 97.5099 235.35C93.9199 223.94 85.7099 218.73 73.8099 219.14",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.68 261.04C333.34 266.53 335.35 271.94 336.53 277.53C337.16 280.52 336.34 283.82 336.17 286.98",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35 300.45C261.02 304.27 260.68 308.1 260.35 311.92",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69 85.45C328.86 87.94 328.55 90.59 329.28 92.9C331.34 99.46 331.2 105.9 329.19 112.38",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5 335.87C211.06 347 205.28 354.02 203.06 361.5",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74 262.04C303.69 270.43 296.45 273.3 288.75 274.85C284.44 275.72 279.8 275.01 275.32 275.01",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2699 50.0401L107.74 44.05",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.62 345.85C155.16 353.02 159.04 358.17 164.6 362.31",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12 252.06C150.45 254.06 149.79 256.05 149.12 258.05",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58 97.4199C165.09 98.2499 161.42 98.6499 158.14 99.9999C150.2 103.26 145.85 110.14 142.19 117.39C138.48 124.74 134.08 131.51 127.68 136.82",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21 43.55L332.17 51.03",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7599 85.45C96.5899 87.78 96.3499 90.1 96.2799 92.43C96.0699 98.75 95.9299 105.07 95.7699 111.39",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 27.5901C122.36 27.7601 126.02 27.9201 129.67 28.0901",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 360.31C339.45 364.85 339.34 369.63 335.17 372.78",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63 259.05V265.04",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2 262.04C123 272.26 131.82 274.42 141.15 275.43C144.25 275.77 147.46 275.18 150.62 275.01",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69 234.11C326.2 233.28 323.68 232.5 321.21 231.61C314.23 229.09 307.2 227.29 299.75 229.59C298.99 229.82 298.1 229.62 297.27 229.62",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 50.53C340.99 47.04 342.07 43.58 342.6 40.05C343.66 33.1 339.55 28.18 335.71 23.06C329.91 15.32 322.69 10.23 312.73 11.24C305.39 11.98 298.55 14.72 292.77 19.6",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.56 120.37C172.1 120.13 169.37 123.05 166.58 125.86",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12 155.29C357.04 166.82 358.03 178.35 350.44 189.21C356.7 193.81 363.97 197.31 366.59 205.17",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.27 27.5901C298.93 27.7601 302.59 27.9201 306.24 28.0901",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55 97.9199C178.89 97.7499 175.23 97.5899 171.58 97.4199",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.26 176.24V179.23",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.69 172.25V176.24",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7 140.32C117.04 139.99 113.38 139.65 109.73 139.32",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.38 119.87C252.87 122.03 256.36 124.19 259.85 126.35",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.41 259.05C231.26 258.77 229.69 263.6 226.43 266.03",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.45 262.04C224.47 263.69 225.49 265.34 226.32 266.68C224.48 273.14 223.24 279.53 220.82 285.43C217.65 293.16 219.32 301.13 218.63 308.94C217.99 316.13 221.28 322.78 223.9 329.39C224.38 330.6 224.28 332.03 224.44 333.36",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.21 358.32C317.44 361.37 313.78 360.85 310.23 360.81",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.16 57.52C339.99 60.68 340.96 63.81 341.6 67.01C342.02 69.12 341.98 71.32 342.15 73.49",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.35 133.34C258.23 140.96 256.79 149.32 258.36 158.28",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63 111.39C350.84 118.2 347.79 123.91 343 128.69C347.69 137.13 352.28 145.39 357.19 154.23C362.62 147.13 370.07 143.91 379.06 144.32",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75 397.23C297.26 401.72 292.88 406.33 288.26 410.67C279.18 419.21 268.34 423.19 255.86 422.68C254.03 422.6 252.2 422.67 250.37 422.67C250.37 422.67 241.33 423.03 236.4 416.68C225.46 413.78 220 403.45 221.35 392.72C221.98 387.72 225.4 383.11 223.44 377.77",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18 116.38H327.18",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7799 57.52C83.4599 62.41 83.2199 67.87 83.7899 73.48",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8699 172.75C46.4199 177.48 43.2899 184.21 41.3799 191.7C41.0299 193.07 40.3999 194.37 39.9099 195.7",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55 279C176.07 278.53 171.08 276.69 166.59 273.51",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7 83.46H117.7",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.24 83.46H306.24",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8099 114.39C75.5899 120.25 78.9499 124.68 82.9099 129.47C86.6899 125.61 90.2199 122 93.7599 118.38",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59 301.95C164.92 305.44 165.26 308.93 165.59 312.43",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.31 76.4701C271.66 74.4701 264.11 71.8401 256.34 70.6701C249.04 69.5701 242.18 72.8601 235.42 75.4801C233.75 76.1301 230.52 78.2401 228.86 78.9101",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29 386.25C291.6 391.45 297.11 393.58 302.26 396.23",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.6 90.4399C368.42 93.7699 372.19 97.1499 376.08 100.4C385.43 108.21 389.72 118.16 389.63 130.34C389.57 137.36 388.82 144.16 386.58 150.8C386.21 151.9 386.22 153.12 386.05 154.28",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25 295.96C293.9 301.03 283.82 303.47 273.34 302.3C262.27 301.07 252.28 297.02 245.89 286.98",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7899 52.53C81.2999 53.36 77.8399 54.37 74.3099 54.98C69.7699 55.76 67.1599 58.16 65.2099 62.45C61.8299 69.9 62.5899 82.25 62.0599 90",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 268.03C201.83 276.01 205.15 283.86 206.25 292.01C207.87 303.97 208.71 316.23 202.06 327.43C201.13 329 201 331.05 200.5 332.88",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.51 77.4699C192.18 76.3099 188.69 75.4799 185.57 73.9199C175.76 69.0299 165.98 70.4599 156.11 73.4799C152.29 74.6499 148.46 75.8099 144.64 76.9699",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 50.53C342.49 51.03 345.3 54.08 347.64 54.51C357.61 56.37 361.07 59.59 362.53 69.5C363.43 75.59 364.1 84.29 364.6 90.44",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.69 295.96C141.58 305.81 162.85 305.48 178.55 289.48",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.169 0.0727539L213.169 420.88",
    stroke: "#738C9A",
    strokeWidth: 0.608242
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.016 212.131L4.11272e-05 212.131",
    stroke: "#738C9A",
    strokeWidth: 0.608242
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_17746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 399.09,
    height: 423.94,
    fill: "white",
    transform: "translate(13.0599)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.a2ec97e60027a60717d0ca3b6743bcb4.svg";
export { ForwardRef as ReactComponent };